import {
  ProductAdviced,
  useAdviceProductsAdviced,
} from "../hooks/useAdviceProductsAdviced";
import {
  Props as CriticalIllessProps,
  CriticalIllnessAdviceCard,
} from "./CriticalIllnessAdviceCard";
import { DeathAdviceCard, Props as DeathProps } from "./DeathAdviceCard";
import {
  DisabilityAdviceCard,
  Props as DisabilityProps,
} from "./DisabilityAdviceCard";

import { ProductBackendName } from "Features/CheckPrice/Products/productTypes";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { getFMSProductName } from "Store/texts/helpers/FMSproductName";
import { useProductTexts } from "Store/texts/hooks";
import { RealRequired } from "Utils/types";
import { FormikProps } from "formik";
import React from "react";
import { AdviceProductDetailsFormValues } from "../../ProductDetails/FormElements/interfaces";
import { sortProducts } from "../utils";
import { ChildAdviceCard } from "./ChildAdviceCard";
import { AdvicePriceFormValues } from "./interfaces";

interface Props {
  adviceProductDetailsFormValues: AdviceProductDetailsFormValues;
  // meta information for sorting of products
  addedWeights: Partial<Record<INSURANCE_NAME_VALUE, number>>;
  formProps: FormikProps<AdvicePriceFormValues>;
}

interface Card {
  name: INSURANCE_NAME_VALUE;
  render: React.FC<DeathProps | DisabilityProps | CriticalIllessProps>;
  data: ProductAdviced | undefined;
  advice: any;
}

export const AdviceCards = ({
  addedWeights,
  ...props
}: Props): React.ReactElement => {
  const {
    deathProductAdviced,
    disabilityProductAdviced,
    criticalIllnessProductAdviced,
  } = useAdviceProductsAdviced();
  const [
    {
      formText: { advice: adviceText },
    },
    lang,
  ] = useProductTexts(getFMSProductName(ProductBackendName.ADVICE));

  const cards = [
    {
      name: INSURANCE_NAME_VALUE.DEATH,
      render: DeathAdviceCard,
      data: deathProductAdviced,
      advice: adviceText.adviceCards.death,
    },
    {
      name: INSURANCE_NAME_VALUE.DISABILITY_FLEX,
      render: DisabilityAdviceCard,
      data: disabilityProductAdviced,
      advice: adviceText.adviceCards.disability,
    },
    {
      name: INSURANCE_NAME_VALUE.CRITICAL_ILLNESS,
      render: CriticalIllnessAdviceCard,
      data: criticalIllnessProductAdviced,
      advice: adviceText.adviceCards.criticalIllness,
    },
  ].reduce<Array<RealRequired<Card>>>((acc, { data, ...rest }) => {
    if (data !== undefined) {
      acc.push({ data, ...rest });
    }

    return acc;
  }, []);

  const products = sortProducts(cards, addedWeights);

  return (
    <>
      {products.map(({ advice, data, name, render: ProductCard }) => (
        <ProductCard
          key={`insurance-advice-card-${name}`}
          {...props}
          insurancePrice={data.insurancePrice}
          insuranceAdvice={data.insuranceAdvice}
          adviceCard={{
            ...advice,
            adviceUnavailableMessages: adviceText.adviceUnavailableMessages,
          }}
          lang={lang}
        />
      ))}
      <ChildAdviceCard />
    </>
  );
};
